import { boolean, InferType, object, string } from 'yup';

export const useSolicitationFormSchema = () =>
	object({
		firstName: string().required('First Name is a required field'),
		lastName: string().required('Last Name is a required field'),
		email: string()
			.required('Email is a required field')
			.email('Please enter a valid email address'),
		company: string().optional(),
		phone: string()
			.optional()
			.test('isValidPhone', 'Please enter a valid phone number', (value) => {
				if (!value) return true;
				return /^\+?[\d\s\-()]{7,15}$/.test(value);
			}),
		mwbe_dbe: boolean().oneOf([true, false]).optional(),
	}).required();

export type SolicitationFormData = InferType<
	ReturnType<typeof useSolicitationFormSchema>
>;
